// /src/i18n/translations.js
// Sorgente unica per tutte le copy del sito. Aggiungere qui nuove lingue.

export const translations = {
  it: {
    lang: { it: 'IT', en: 'EN', switchTo: 'Cambia lingua' },

    nav: {
      menu: 'Menu',
      segreto: 'Il Segreto',
      sedi: 'Le Sedi',
      cta_discount: 'Clicca per 2,50€ di sconto',
    },

    hero: {
      tagline: 'crudo squacquerone e rucola, crudo e mozzarella, mortadella burrata e pesto di pistacchio.....',
      banner: 'Smettila di mangiare sempre le solite combinazioni',
      h1_line1: 'Vieni a fare una pausa',
      h1_line2: 'come si deve da Sfarinà',
      h2: 'Le migliori piadine gourmet sono qui che ti aspettano!',
      btn_menu: 'Vai al menu',
    },

    identita: {
      title_pre: 'Mangi sempre le',
      title_highlight: 'stesse noiose cose?',
      kicker: 'Le piadine di sempre',
      list_intro: 'Magari le riconosci:',
      list: ['Crudo, Squacquerone e Rucola', 'Cotto e Mozzarella', 'Mortadella, Burrata e Pesto di Pistacchio'],
      question: 'Non sei stanco di mangiare sempre le stesse piadine?',
      paragraph: 'Ci pensi? Ogni volta che entri in una piadineria sai già cosa troverai. Le solite tre combinazioni scritte su una lavagnetta, gli stessi ingredienti messi insieme senza troppa fantasia.',
      conclusion: "Noi di Sfarinà abbiamo scelto un'altra strada",
    },

    contrasto: {
      title_pre: 'Ma come abbiamo fatto a creare un match così perfetto tra',
      title_highlight: 'ingredienti D.O.P. e i nostri impasti artigianali?',
      hook_pre: 'È tutto merito del ',
      hook_h: 'know how unico dal nostro chef',
      hook_end: ', che avendo lavorato in cucine di alta classe, ha maturato delle esperienze e dei concetti fondamentali…',
      box1_pre: '…questo ci ha permesso di ',
      box1_h: 'esaltare al massimo le classiche ricette bolognesi',
      box1_end: ' rendendo anche una cosa semplice un piacere per il palato,',
      box2_pre: '…inoltre questa combinazione di esperienza stellata e cura ai dettagli ci ha permesso di immaginare i ',
      box2_h: 'migliori abbinamenti',
      box2_end: ' in modo da riuscire a soddisfare tutti i tipi di voglie e palati!',
      card_p1: 'Ogni proposta nasce da uno studio attento dei sapori, delle consistenze e dell\u2019equilibrio tra gli ingredienti, così da offrire un\u2019esperienza ricca, appagante e sempre riconoscibile.',
      card_p2_pre: 'Nulla viene lasciato al caso: dalla scelta delle materie prime fino alla preparazione finale, ',
      card_p2_h: 'ogni dettaglio è pensato per garantire qualità, gusto e personalità irripetibili.',
      btn_menu: 'Vai al menu!',
    },

    menu: {
      title: 'Le nostre proposte golose',
      subtitle: 'piadine / crescioni / rotoli / french tacos',
      intro_pre: 'Oltre alle nostre proposte più classiche, da Sfarinà trovi anche ',
      intro_h: 'varianti pensate per soddisfare ogni tipo di appetito',
      intro_end: ' e regalare nuove esperienze, sempre mantenendo la qualità e l\u2019artigianalità che ci rendono unici.',
      piadine: {
        title: 'PIADINE',
        body_pre: 'Le nostre piadine artigianali nascono da un ',
        body_h: 'impasto lavorato a mano e da ingredienti scelti con cura',
        body_end: ' per offrirti gusto, qualità e una pausa davvero memorabile.',
        link: 'Vedi tutte le piadine',
      },
      crescioni: {
        title: 'CRESCIONI',
        body_pre: 'Preparati con i nostri impasti fatti a mano e farciti con ingredienti selezionati a differenza delle piadine ',
        body_h: 'i crescioni vengono chiusi prima della cottura, sigillando il ripieno all\u2019interno dell\u2019impasto',
        body_end: '.',
        link: 'Scopri i crescioni',
      },
      rotoli: {
        title: 'I ROTOLI',
        p1_pre: 'Se pensi di aver già visto tutto, aspetta di incontrare il nostro ',
        p1_h: 'rotolo da 60 cm, quasi un chilo di pura artigianalità',
        p1_end: ', lungo quanto 4 lattine di coca cola messe in fila.',
        p2_pre: 'Una sfoglia tirata a mano, ',
        p2_h: 'farcita fino all\'ultimo centimetro',
        p2_end: ', pensata per chi non accetta compromessi quando si tratta di mangiare bene.',
        p3_pre: 'Non è solo un rotolo, è una dichiarazione d\'intenti: da Sfarinà, ',
        p3_h: 'quando diciamo abbondante, lo diciamo sul serio.',
        link: 'Esplora i rotoli da 40 e 60 cm',
      },
      tacos: {
        title: 'FRENCH TACOS',
        body_pre: 'Per chi ama i sapori decisi e le proposte moderne proponiamo anche i nostri ',
        body_h: 'French Tacos strapieni di farcitura',
        body_end: ', perfetti per chi vuole assaporare al meglio le nostre combinazioni.',
        link: 'Scopri i French Tacos',
      },
      chiusura: {
        title: 'TRE ALTERNATIVE, UN SOLO STANDARD',
        body_pre: 'Tre alternative diverse, tutte caratterizzate dal ',
        body_h: 'nostro impasto artigianale, ingredienti scelti con cura e la voglia di offrirti un prodotto speciale',
        body_end: ', che finirà per farti tornare ancora e ancora!',
        btn_menu: 'Vai al menù!',
      },
    },

    segreto: {
      title: 'Un processo unico — il segreto di Sfarinà',
      subtitle: 'Il metodo Mani e Fornaio',
      tag: 'Fatto a mano, ogni giorno',
      hook_pre: 'Ogni mattina, quando Bologna è ancora silenziosa, prendiamo ',
      hook_h: 'farina, strutto, acqua e sale e impastiamo con le mani.',
      bullets: ['Nessuna macchina', 'Nessun preparato industriale', 'Nessuna scorciatoia'],
      bullets_text_h: 'Solo artigianalità pura',
      bullets_text_end: ', perché siamo convinti che la qualità di quello che mangi inizia da come viene lavorato l\'impasto.',
      quote_pre: 'È qui che nasce la differenza. Il nostro ',
      quote_h: 'metodo stellato',
      quote_end: ' rende la sfoglia unica: d\u2019altronde, come può una macchina sentire la giusta consistenza dell\u2019impasto sotto le dita?',
      final_pre: 'Nessun compromesso sulle materie prime, zero preparati veloci, ',
      final_h1: 'ogni singolo impasto fatto a mano',
      final_mid: '. I nostri prodotti sono ormai riconosciuti in tutta Bologna perché, oltre ad essere generosi, riescono a ',
      final_h2: 'mantenere le loro proprietà uniche anche ore dopo la preparazione',
      final_end: ' per restituire le migliori sensazioni ad ogni morso.',
      conclusion: 'Sfarinà è la tua pausa veloce e gourmet.',
      btn_menu: 'Vai al menu!',
    },

    compare: {
      title: 'Sfarinà vs gli altri',
      subtitle: 'Tre caratteristiche, una scelta che fa la differenza.',
      best_choice: 'La Scelta Migliore',
      cols: {
        super: { line1: 'Piadina del', line2: 'supermercato' },
        sfarina: 'SFARINÀ',
        tourist: { line1: 'Piadina acchiappa', line2: 'turisti' },
      },
      rows: [
        {
          key: 'impasto',
          label: 'L\u2019impasto',
          super: 'Industriale, precotto e pieno di conservanti per farlo durare mesi.',
          sfarina: 'Realizzato impastando a mano ogni mattina',
          tourist: 'Congelato e di bassa qualità.',
        },
        {
          key: 'dimensioni',
          label: 'Le dimensioni',
          super: 'Standard, troppo sottile e \u201cvuota\u201d al centro.',
          sfarina: 'I nostri Rotoli da 60cm sarebbero in grado di saziare anche un dinosauro',
          tourist: 'Piccole e insignificanti, se non ne prendi 2 in meno di mezz\u2019ora hai di nuovo fame.',
        },
        {
          key: 'ingredienti',
          label: 'Ingredienti',
          super: 'Letteralmente meno costano meglio è, molto scadenti.',
          sfarina: 'Solo eccellenze. Salumi selezionati e prodotti locali freschi.',
          tourist: 'Ingredienti di media qualità dove senti solo gusto di salse.',
        },
        {
          key: 'varieta',
          label: 'Varietà',
          super: 'Oltre alle solite 2 classiche versioni non troverai altre opzioni.',
          sfarina: 'Abbinamenti unici inventati da uno chef con esperienza in cucine stellate',
          tourist: 'Classiche proposte tradizionali, oppure abbinamenti spesso improvvisati, senza una reale attenzione ai dettagli.',
        },
      ],
    },

    sedi: {
      title: 'Dove trovarci',
      mercato: {
        name: 'Sfarinà — Mercato delle Erbe',
        address: 'Via Belvedere 6, Bologna',
        subtitle: 'Dentro il Mercato delle Erbe',
        offer: 'Piadine, crescioni, rotoli e French Tacos da asporto.',
      },
      cefalonia: {
        badge: 'Centro storico',
        name: 'Sfarinà — Cefalonia',
        address: 'Via Caduti di Cefalonia 2b, Bologna',
        subtitle: 'a 2 passi da Piazza Maggiore',
        offer: 'Piadine, Panini, Crescioni, Rotoli e French Tacos da asporto.',
      },
      hours_title: 'Orari di apertura',
      days: { mon: 'Lunedì', tue: 'Martedì', wed: 'Mercoledì', thu: 'Giovedì', fri: 'Venerdì', sat: 'Sabato', sun: 'Domenica' },
      today: 'Oggi',
      btn_maps: 'Apri su Google Maps',
      btn_call: 'Chiama',
    },

    cta_final: {
      title: 'La prossima pausa falla come si deve.',
      subtitle: 'Scegli una pausa veloce, gourmet e memorabile.',
      link_sedi: 'Scopri le sedi',
      link_menu: 'Vai al menu',
    },

    menu_dettaglio: {
      kicker: 'Menù completo',
      title_pre: 'Sfoglia tutte le nostre ',
      title_h: 'creazioni',
      intro: 'Scarica il menù in PDF di ogni categoria, oppure dai un\'occhiata in negozio.',
      view_pdf: 'Scarica il menù',
      piadine_title: 'Le Piadine',
      piadine_body: 'Sfoglia tirata a mano ogni mattina, farcita con ingredienti DOP e selezionati.',
      crescioni_title: 'I Crescioni',
      crescioni_body: 'Chiusi prima della cottura per sigillare i sapori. Ricetta della tradizione emiliana.',
      rotoli_title: 'I Rotoli (40 e 60 cm)',
      rotoli_body: 'Il formato maxi del nostro impasto: ricco, abbondante, lungo fino a 60 cm.',
      tacos_title: 'I French Tacos',
      tacos_body: 'La nostra reinterpretazione moderna: gusto deciso, sapori bolognesi e impasto artigianale.',
      protagonista: 'Protagonista',
      cta: 'Sblocca 2,50€ di sconto sul tuo primo ordine',
    },

    footer: {
      tagline: 'Piadineria artigianale premium.',
      nav_title: 'Navigazione',
      info_title: 'Informazioni',
      privacy: 'Privacy Policy',
      cookie: 'Cookie Policy',
      copyright_pre: 'Copyright ©',
      copyright_post: 'Sfarinà. Tutti i diritti riservati.',
      vat: 'P.IVA IT03599701202',
    },

    modal: {
      kicker: 'Offerta riservata',
      title_line1: 'Ricevi 2,50€ di sconto',
      title_line2: 'sulla tua prima pausa da Sfarinà',
      subtitle: 'Lascia i tuoi dati: ti invieremo subito il coupon su whatsapp.',
      labels: { nome: 'Nome', cognome: 'Cognome', email: 'Email', telefono: 'Numero di Telefono' },
      phone_hint_pre: "Inserisci il numero con il prefisso internazionale (es. ",
      phone_hint_strong: '+39',
      phone_hint_post: " per l'Italia).",
      privacy: 'Acconsento al trattamento dei dati personali per ricevere il coupon e comunicazioni promozionali da Sfarinà.',
      submit: 'Ricevi il tuo sconto da 2,50€',
      submitting: 'Invio in corso…',
      footer_note: 'I tuoi dati sono al sicuro. Puoi disiscriverti in ogni momento.',
      success_title: 'Grazie',
      success_body_pre: 'Ti abbiamo riservato il ',
      success_body_h: 'coupon di 2,50€ di sconto',
      success_body_post: '.',
      success_body_2: 'Riceverai a breve un messaggio su WhatsApp con tutti i dettagli per riscattarlo in negozio.',
      success_close: 'Chiudi',
      err_nome: 'Inserisci il tuo nome.',
      err_cognome: 'Inserisci il tuo cognome.',
      err_email: 'Inserisci un indirizzo email valido.',
      err_phone: 'Inserisci il numero con il prefisso internazionale (es. +393331234567).',
      err_privacy: 'Devi accettare la Privacy Policy per ricevere lo sconto.',
      err_generic: 'Si è verificato un errore. Riprova tra qualche istante.',
    },
  },

  en: {
    lang: { it: 'IT', en: 'EN', switchTo: 'Change language' },

    nav: {
      menu: 'Menu',
      segreto: 'Our Story',
      sedi: 'Locations',
      cta_discount: 'Get €2.50 off — click here',
    },

    hero: {
      tagline: 'raw ham squacquerone & rocket, raw ham & mozzarella, mortadella burrata & pistachio pesto…',
      banner: 'Stop eating the same boring combos',
      h1_line1: 'Take a proper break',
      h1_line2: 'at Sfarinà',
      h2: 'The best gourmet piadine in Bologna are waiting for you!',
      btn_menu: 'See the menu',
    },

    identita: {
      title_pre: 'Still eating the',
      title_highlight: 'same boring stuff?',
      kicker: 'The usual piadine',
      list_intro: 'You probably know them by heart:',
      list: ['Raw Ham, Squacquerone & Rocket', 'Cooked Ham & Mozzarella', 'Mortadella, Burrata & Pistachio Pesto'],
      question: "Aren't you tired of always eating the same piadine?",
      paragraph: "Think about it: every time you walk into a piadina shop you already know what you'll find. The usual three combinations chalked on a blackboard, the same ingredients thrown together with no imagination.",
      conclusion: 'At Sfarinà we took a different path',
    },

    contrasto: {
      title_pre: 'How did we manage to create such a perfect match between',
      title_highlight: 'D.O.P. ingredients and our handmade dough?',
      hook_pre: "It's all thanks to our ",
      hook_h: "chef's unique know-how",
      hook_end: '. Having worked in high-end kitchens, he gathered fundamental experiences and ideas…',
      box1_pre: '…allowing us to ',
      box1_h: 'elevate classic Bolognese recipes',
      box1_end: ' and turn even the simplest dish into a pleasure for the palate,',
      box2_pre: '…plus this combination of starred expertise and attention to detail let us imagine the ',
      box2_h: 'best pairings',
      box2_end: ' to satisfy every craving and every palate!',
      card_p1: 'Every proposal is born from a careful study of flavours, textures and ingredient balance — to offer a rich, satisfying and unmistakable experience.',
      card_p2_pre: 'Nothing is left to chance: from sourcing to final preparation, ',
      card_p2_h: 'every detail is designed to guarantee quality, taste and unrepeatable personality.',
      btn_menu: 'See the menu',
    },

    menu: {
      title: 'Our delicious creations',
      subtitle: 'piadine / crescioni / rolls / french tacos',
      intro_pre: 'Beyond our classic options, at Sfarinà you\'ll also find ',
      intro_h: 'variants designed for every kind of appetite',
      intro_end: ' — new experiences, always with the quality and craftsmanship that make us unique.',
      piadine: {
        title: 'PIADINE',
        body_pre: 'Our handmade piadine are born from ',
        body_h: 'a hand-kneaded dough and carefully selected ingredients',
        body_end: ', for a truly memorable break.',
        link: 'See all piadine',
      },
      crescioni: {
        title: 'CRESCIONI',
        body_pre: 'Made with our handmade dough and filled with selected ingredients — unlike piadine, ',
        body_h: 'crescioni are sealed before cooking, locking the filling inside the dough',
        body_end: '.',
        link: 'Discover the crescioni',
      },
      rotoli: {
        title: 'THE ROLLS',
        p1_pre: "If you think you've seen it all, wait until you meet our ",
        p1_h: '60 cm roll, nearly a kilogram of pure craftsmanship',
        p1_end: ', as long as four Coke cans in a row.',
        p2_pre: 'Hand-stretched dough, ',
        p2_h: 'filled to the very last centimetre',
        p2_end: ", designed for those who don't compromise on eating well.",
        p3_pre: "It's not just a roll, it's a statement: at Sfarinà, ",
        p3_h: 'when we say generous, we mean it.',
        link: 'Explore the 40 and 60 cm rolls',
      },
      tacos: {
        title: 'FRENCH TACOS',
        body_pre: 'For those who love bold flavours and modern proposals, we also serve our ',
        body_h: 'French Tacos packed with filling',
        body_end: ', perfect for those who want to fully savour our combinations.',
        link: 'Discover the French Tacos',
      },
      chiusura: {
        title: 'THREE OPTIONS, ONE STANDARD',
        body_pre: 'Three different options, all defined by ',
        body_h: 'our handmade dough, carefully selected ingredients and the desire to give you something truly special',
        body_end: ' — bound to make you come back again and again!',
        btn_menu: 'Open the menu',
      },
    },

    segreto: {
      title: 'A unique process — the Sfarinà secret',
      subtitle: 'The Hands and Oven method',
      tag: 'Handmade, every day',
      hook_pre: 'Every morning, while Bologna is still quiet, we take ',
      hook_h: 'flour, lard, water and salt and knead by hand.',
      bullets: ['No machines', 'No industrial mixes', 'No shortcuts'],
      bullets_text_h: 'Just pure craftsmanship',
      bullets_text_end: ' — because we believe quality starts from how the dough is worked.',
      quote_pre: "That's where the difference is born. Our ",
      quote_h: 'starred method',
      quote_end: ' makes the dough unique: after all, how can a machine feel the right consistency under its fingers?',
      final_pre: 'No compromise on raw materials, no quick mixes, ',
      final_h1: 'every single dough kneaded by hand',
      final_mid: '. Our products are now known throughout Bologna because, besides being generous, they ',
      final_h2: 'keep their unique qualities even hours after preparation',
      final_end: ' — delivering the best sensations with every bite.',
      conclusion: 'Sfarinà is your fast, gourmet break.',
      btn_menu: 'See the menu',
    },

    compare: {
      title: 'Sfarinà vs. the rest',
      subtitle: 'Three traits, one choice that makes the difference.',
      best_choice: 'The Best Choice',
      cols: {
        super: { line1: 'Supermarket', line2: 'piadina' },
        sfarina: 'SFARINÀ',
        tourist: { line1: 'Tourist-trap', line2: 'piadina' },
      },
      rows: [
        {
          key: 'impasto',
          label: 'The dough',
          super: 'Industrial, pre-cooked, packed with preservatives to last for months.',
          sfarina: 'Hand-kneaded fresh every morning',
          tourist: 'Frozen and low quality.',
        },
        {
          key: 'dimensioni',
          label: 'Size',
          super: 'Standard, too thin and "empty" in the middle.',
          sfarina: 'Our 60 cm rolls could feed a dinosaur',
          tourist: 'Tiny and forgettable — if you don\'t grab two, you\'re hungry again in half an hour.',
        },
        {
          key: 'ingredienti',
          label: 'Ingredients',
          super: 'Cheaper is better — quite poor quality.',
          sfarina: 'Only the best. Selected cold cuts and fresh local products.',
          tourist: 'Mid-range ingredients where all you taste is sauce.',
        },
        {
          key: 'varieta',
          label: 'Variety',
          super: 'Beyond the usual 2 classic versions you won\'t find much else.',
          sfarina: 'Unique pairings invented by a chef with starred-kitchen experience',
          tourist: 'Classic offerings, or improvised pairings without real attention to detail.',
        },
      ],
    },

    sedi: {
      title: 'Find us',
      mercato: {
        name: 'Sfarinà — Mercato delle Erbe',
        address: 'Via Belvedere 6, Bologna',
        subtitle: 'Inside the Mercato delle Erbe',
        offer: 'Piadine, crescioni, rolls and French Tacos — takeaway.',
      },
      cefalonia: {
        badge: 'City centre',
        name: 'Sfarinà — Cefalonia',
        address: 'Via Caduti di Cefalonia 2b, Bologna',
        subtitle: '2 minutes from Piazza Maggiore',
        offer: 'Piadine, sandwiches, crescioni, rolls and French Tacos — takeaway.',
      },
      hours_title: 'Opening hours',
      days: { mon: 'Monday', tue: 'Tuesday', wed: 'Wednesday', thu: 'Thursday', fri: 'Friday', sat: 'Saturday', sun: 'Sunday' },
      today: 'Today',
      btn_maps: 'Open in Google Maps',
      btn_call: 'Call',
    },

    cta_final: {
      title: 'Make your next break the proper one.',
      subtitle: 'Choose a fast, gourmet, memorable break.',
      link_sedi: 'See our locations',
      link_menu: 'See the menu',
    },

    menu_dettaglio: {
      kicker: 'Full menu',
      title_pre: 'Browse all our ',
      title_h: 'creations',
      intro: 'Download the PDF menu of each category, or check it out in store.',
      view_pdf: 'Download the menu',
      piadine_title: 'The Piadine',
      piadine_body: 'Dough stretched fresh every morning, filled with DOP and selected ingredients.',
      crescioni_title: 'The Crescioni',
      crescioni_body: 'Sealed before cooking to lock in the flavours. A recipe from Emilia\'s tradition.',
      rotoli_title: 'The Rolls (40 and 60 cm)',
      rotoli_body: 'The XL version of our dough: rich, generous, up to 60 cm long.',
      tacos_title: 'The French Tacos',
      tacos_body: 'Our modern take: bold flavours, Bolognese spirit, handmade dough.',
      protagonista: 'Star item',
      cta: 'Unlock €2.50 off your first order',
    },

    footer: {
      tagline: 'Premium handmade piadineria.',
      nav_title: 'Navigation',
      info_title: 'Info',
      privacy: 'Privacy Policy',
      cookie: 'Cookie Policy',
      copyright_pre: 'Copyright ©',
      copyright_post: 'Sfarinà. All rights reserved.',
      vat: 'VAT IT03599701202',
    },

    modal: {
      kicker: 'Exclusive offer',
      title_line1: 'Get €2.50 off',
      title_line2: 'on your first break at Sfarinà',
      subtitle: 'Leave your details: we\'ll send the coupon straight to WhatsApp.',
      labels: { nome: 'First name', cognome: 'Last name', email: 'Email', telefono: 'Phone number' },
      phone_hint_pre: 'Enter your number with the international prefix (e.g. ',
      phone_hint_strong: '+39',
      phone_hint_post: ' for Italy).',
      privacy: 'I consent to the processing of my personal data to receive the coupon and promotional communications from Sfarinà.',
      submit: 'Get my €2.50 discount',
      submitting: 'Sending…',
      footer_note: 'Your data is safe. You can unsubscribe at any time.',
      success_title: 'Thanks',
      success_body_pre: 'We\'ve set aside your ',
      success_body_h: '€2.50 discount coupon',
      success_body_post: '.',
      success_body_2: "You'll receive a WhatsApp message shortly with all the details to redeem it in store.",
      success_close: 'Close',
      err_nome: 'Enter your first name.',
      err_cognome: 'Enter your last name.',
      err_email: 'Enter a valid email address.',
      err_phone: 'Enter your number with the international prefix (e.g. +393331234567).',
      err_privacy: 'You must accept the Privacy Policy to receive the discount.',
      err_generic: 'Something went wrong. Please try again in a moment.',
    },
  },
};
